import type { Currency } from './types';

export function formatAmount(n: number | string, currency: Currency): string {
  const num = typeof n === 'string' ? parseFloat(n) : n;
  const abs = Math.abs(num);
  const formatted = currency === 'SYP'
    ? abs.toLocaleString('en-US', { maximumFractionDigits: 0 })
    : abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const sign = num < 0 ? '-' : '';
  return `${sign}${formatted} ${currency}`;
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' }) +
         ' · ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function parseAmountInput(s: string): number | null {
  const cleaned = s.replace(/[,\s]/g, '');
  if (!cleaned) return null;
  const n = parseFloat(cleaned);
  if (!isFinite(n) || n <= 0) return null;
  return n;
}

// Formats a Date as 'YYYY-MM-DDTHH:mm' in LOCAL time — the value format
// expected by <input type="datetime-local">.
export function toDatetimeLocal(d: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
         `T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Converts a 'YYYY-MM-DDTHH:mm' local value back to a UTC ISO string for the API.
// The value has no timezone, so the Date constructor reads it as local time.
export function datetimeLocalToISO(value: string): string {
  const d = new Date(value);
  return isNaN(d.getTime()) ? new Date().toISOString() : d.toISOString();
}
